<template>
  <input v-if="type == 'percentage'" class="InputPercentage" :class="inputClasses" :disabled="disabled"
    @keypress="onKeyPress" @paste="onPaste" v-on:blur="onFocusOut" v-model="display" @change="onChange" />
  <currency-input v-else v-on:blur="onFocusOut" v-model="ValueMapper" :class="inputClasses" :disabled="disabled" />
</template>

<script>
export default {
  name: "decimal-field",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      default: ""
    },
    maxDecimalPlaces: {
      type: Number,
      default: 2
    },
    type: {
      type: String,
      default: 'percentage' // or currency
    },
    value: {
      type: Number,
      default: 0.00
    }
  },
  data: function () {
    return {
      display: null,
    };
  },
  model: {
    event: `modified`
  },
  methods: {
    changeValue(newValue) {
      this.$emit("modified", newValue);
      this.$emit("onchange", newValue);
    },
    onChange() {
      let initialValue = "0";
      if (this.display.replace('%', '').length > 0) {
        initialValue = this.display;
      }
      let value = initialValue.replace(/\,/gm, '.')
      // if(isNaN(value)){ value = 0;}
      let finalValue = parseFloat(value).toFixed(this.maxDecimalPlaces);
      this.display = finalValue.replace(/\./gm, ',');
      
    },
    onFocusOut(ev) {
      this.$emit("onfocusout", ev);
    },
    onKeyPress(ev) {
      const codeIsNumber = /^[0-9]$/i.test(ev.key);
      const codeIsComma = (ev.code == 'Comma' || ev.code == 'NumpadDecimal' || ev.code == 'Period') ? true : false;
      if ( !codeIsNumber && !codeIsComma) {
        ev.preventDefault();
      } else {
        const isComma = (this.display.includes(',') || this.display.includes('.'));
        const hasComma = this.display == null ? false : isComma;
        if (codeIsComma && hasComma) {
          ev.preventDefault();
          return ;
        }

        if (codeIsNumber && hasComma) {
          const delimeter = this.display.includes('.') ? '.' : ',';
          const numDecimalPlace = this.display.split(delimeter)[1].length;
          const target = ev.target;

          let isSelected = false;
          if (target.selectionEnd - target.selectionStart >= 1) {
            isSelected = true;
          }

          if (numDecimalPlace >= this.maxDecimalPlaces && !isSelected) {
            ev.preventDefault();
          }

          if (delimeter == '.') {
            const newValue = target.value.replace(/\./g, ',');
            target.value = newValue;
          }
        }
      }
    },
    onPaste(ev) {
      ev.preventDefault();

      let pasteData = ev.clipboardData.getData('text/plain');
      let onlyNumberAndComma = pasteData.replace(/[^\d,]/gm, '');
      let split = onlyNumberAndComma.split(',');

      let newValue = split[1] != null ? split[0] + ',' + split[1] : split[0];

      if (split[1] != null && split[1].length > 2) {
        let replacedComma = newValue.replace(/,/gm, '.');
        let valFloat = parseFloat(replacedComma).toFixed(this.maxDecimalPlaces);
        this.display = valFloat.replace(/\./gm, ',');

      } else {
        this.display = newValue;
      }

    },
  },
  mounted() {
    if (this.value != null) {
      if (this.type == 'percentage' || this.type == 'currency') {
        const fixedValue = parseFloat(Math.round(this.value * 100) / 100).toFixed(2);
        const result = fixedValue.replace(/\./gm, ',');
        this.display = result;
      }
    }
  },
  computed: {
    inputClasses() {
      return this.inputClass + " form-control";
    },
    ValueMapper: {
      get() {
        return this.value;
      },
      set(value) {
        this.changeValue(value);
      }
    }
  },
  watch: {
    display: function (nv) {
      if (nv != null) {
        let commaToDot = nv.replace(/,/gm, ".");
        if (commaToDot != null) {
          let value = commaToDot != '' ? commaToDot : 0.0;
          this.changeValue(
            parseFloat(value)
          );
          return;
        }
      }
      this.changeValue(0.0);
    },
    disabled: function (nv, ov) {
      if (nv != null) {
        if (nv == false && ov == true) {
          this.display = this.display.replace(/%/gm, '');
        }
      }
    },
    type: function (nv, ov) {
      if (nv == 'percentage' && ov == 'currency') {
        let value = parseFloat((this.value * 100) / 100).toFixed(this.maxDecimalPlaces);
        this.display = value.replace(/\./gm, ',');
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/decimal-field.vue